<ul class="nav nav-tabs ml-0 pl-0 tabs-shadow">
  <li class="li-m pb-2 mr-6 light-text primary-text" *ngFor="let tab of tabs; let i = index" (click)="selectTab(tab,i)"
    [ngClass]="clickchange  && !tab.disable ? 'enable-action':'disable-action'" [class.active]="tab.active">
    <a>{{tab.title}}</a>
  </li>
</ul> 
<ng-content></ng-content>